/* eslint-disable */
export default {
  install (Vue, options) {
    Vue.prototype.$configEntryById = function(section, id) {
      let element = {}

      for (const key in options.config[section]) {
        const entry = options.config[section][key]
        if (entry.id === id) {
          element = Object.assign({}, entry)
        }
      }

      return element
    }

    Vue.prototype.$config = Object.assign({}, options.config)
  },
}
